module.exports = __webpack_public_path__ + "static/media/5.03b23b98.jpg";